var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.modalStatus
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Edit Profile ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "error-messages": _vm.errors.collect("First Name"),
                        label: "First Name",
                        required: "",
                        readonly: "",
                        disabled: "",
                        name: "First Name"
                      },
                      model: {
                        value: _vm.userData.firstname,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "firstname", $$v)
                        },
                        expression: "userData.firstname"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "error-messages": _vm.errors.collect("Last Name"),
                        label: "Last Name",
                        required: "",
                        readonly: "",
                        disabled: "",
                        name: "Last Name"
                      },
                      model: {
                        value: _vm.userData.lastname,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "lastname", $$v)
                        },
                        expression: "userData.lastname"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "error-messages": _vm.errors.collect("Email"),
                        label: "Email",
                        required: "",
                        disabled: "",
                        name: "Email"
                      },
                      model: {
                        value: _vm.userData.email,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "email", $$v)
                        },
                        expression: "userData.email"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      attrs: {
                        "error-messages": _vm.errors.collect("Organization"),
                        label: "Organization",
                        required: "",
                        name: "Organization"
                      },
                      model: {
                        value: _vm.userData.companyname,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "companyname", $$v)
                        },
                        expression: "userData.companyname"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "error-messages": _vm.errors.collect("Address 1"),
                        label: "Address 1",
                        required: "",
                        name: "Address 1"
                      },
                      model: {
                        value: _vm.userData.address1,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "address1", $$v)
                        },
                        expression: "userData.address1"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      attrs: {
                        "error-messages": _vm.errors.collect("Address 2"),
                        label: "Address 2",
                        required: "",
                        name: "Address 2"
                      },
                      model: {
                        value: _vm.userData.address2,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "address2", $$v)
                        },
                        expression: "userData.address2"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "4"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "error-messages": _vm.errors.collect("City"),
                        label: "City",
                        required: "",
                        name: "City"
                      },
                      model: {
                        value: _vm.userData.city,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "city", $$v)
                        },
                        expression: "userData.city"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "4"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "error-messages": _vm.errors.collect("State"),
                        label: "State",
                        required: "",
                        name: "State"
                      },
                      model: {
                        value: _vm.userData.state,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "state", $$v)
                        },
                        expression: "userData.state"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "4"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "error-messages": _vm.errors.collect("Zip Code"),
                        label: "Zip Code",
                        required: "",
                        name: "Zip Code"
                      },
                      model: {
                        value: _vm.userData.postcode,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "postcode", $$v)
                        },
                        expression: "userData.postcode"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "5"
                    }
                  },
                  [
                    _c("gg-input-label", [_vm._v("Country")]),
                    _c("v-autocomplete", {
                      attrs: {
                        outlined: "",
                        dense: "",
                        "error-messages": _vm.errors.collect("Country"),
                        items: _vm.countries,
                        "item-text": "name",
                        "item-value": "code",
                        name: "Country"
                      },
                      model: {
                        value: _vm.userData.country,
                        callback: function callback($$v) {
                          _vm.$set(_vm.userData, "country", $$v)
                        },
                        expression: "userData.country"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "7"
                    }
                  },
                  [
                    _c(
                      "v-row",
                      {
                        attrs: {
                          "no-gutters": ""
                        }
                      },
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12"
                            }
                          },
                          [_c("gg-input-label", [_vm._v("Phone Number")])],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pr-5",
                            attrs: {
                              cols: "4"
                            }
                          },
                          [
                            _c("v-combobox", {
                              attrs: {
                                outlined: "",
                                dense: "",
                                name: "suffix",
                                autocomplete: "suffix",
                                "auto-select-first": "",
                                items: _vm.dialCodes
                              },
                              model: {
                                value: _vm.dialCode,
                                callback: function callback($$v) {
                                  _vm.dialCode = $$v
                                },
                                expression: "dialCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex flex-column",
                            attrs: {
                              cols: "8"
                            }
                          },
                          [
                            _c("gg-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mt-auto",
                              attrs: {
                                "error-messages": _vm.errors.collect(
                                  "Phone Number"
                                ),
                                required: "",
                                name: "Phone"
                              },
                              model: {
                                value: _vm.phoneNumber,
                                callback: function callback($$v) {
                                  _vm.phoneNumber = $$v
                                },
                                expression: "phoneNumber"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: "",
                  disabled: _vm.loading
                },
                on: {
                  click: _vm.close
                }
              },
              [
                _vm._v(" Cancel "),
                _c(
                  "span",
                  {
                    staticClass: "visually-hidden text-lowercase"
                  },
                  [_vm._v(" button ")]
                )
              ]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.saveChanges
                }
              },
              [
                _vm._v(" Save Changes "),
                _c(
                  "span",
                  {
                    staticClass: "visually-hidden text-lowercase"
                  },
                  [_vm._v(" button ")]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }